import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { AuditLog } from '../../../shared/models';
import {
  ShelfReplenishmentPhotoListContent,
  ShelfReplenishmentPhotoSearchCriteria,
  ShelfReplenishmentPhotoTaskSummaryResponse,
  ShelfReplenishmentPhotoView
} from '../model/shelf-replenishment-photo.model';
import { shelfReplenishmentPhotoAction } from './shelf-replenishment-photo.actions';

export interface ShelfReplenishmentPhotoState {
  shelfReplenishmentPhotoView: ShelfReplenishmentPhotoView | null;
  auditLogs: AuditLog[];
  selected: ShelfReplenishmentPhotoListContent[];
  criteriaObject: ShelfReplenishmentPhotoSearchCriteria;
  totalElements: number;
  totalPages: number;
  summary: ShelfReplenishmentPhotoTaskSummaryResponse;
}

export const adapter: EntityAdapter<ShelfReplenishmentPhotoListContent> =
  createEntityAdapter<ShelfReplenishmentPhotoListContent>({
    selectId: (model: ShelfReplenishmentPhotoListContent) => model.jobNo
  });

export const initialState: ShelfReplenishmentPhotoState = adapter.getInitialState({
  shelfReplenishmentPhotoView: null,
  auditLogs: null,
  selected: [],
  criteriaObject: {
    page: 0,
    size: 20,
    status: null,
    shelfTypeCode: null,
    storeCode: null,
    receivedDateFrom: null,
    receivedDateTo: null,
    verifiedDateFrom: null,
    verifiedDateTo: null
  },
  totalElements: 0,
  totalPages: 20,
  summary: null
});

export const shelfReplenishmentPhotoReducer = createReducer<ShelfReplenishmentPhotoState>(
  initialState,
  on(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoViewResponse, (state, { response }) => {
    return { ...state, shelfReplenishmentPhotoView: response };
  }),
  on(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoActionReset, state => {
    return { ...state, shelfReplenishmentPhotoView: null, auditLogs: null };
  }),
  on(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoListActionReset, state => {
    return { ...state, ...initialState };
  }),
  on(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoActionHistoryResponse, (state, { response }) => {
    return { ...state, auditLogs: response };
  }),
  on(
    shelfReplenishmentPhotoAction.shelfReplenishmentPhotoListResponse,
    (state, action): ShelfReplenishmentPhotoState => {
      return {
        ...state,
        selected: action.data.content,
        totalElements: action.data.totalElements,
        criteriaObject: {
          ...state.criteriaObject,
          page: action.data.page,
          size: action.data.size
        }
      };
    }
  ),
  on(shelfReplenishmentPhotoAction.shelfReplenishmentPhotoTaskSummaryResponse, (state, { response }) => {
    return { ...state, summary: response };
  })
);
